import { HttpError, useOne } from '@refinedev/core';

type BackgroundProcessStatus = 'PENDING' | 'PROCESSING' | 'SUCCESS' | 'FAILED';

type MeetingAgenda = {
  markdown: string;
  fileId: number;
  backgroundProcess?: {
    id: string;
    status: BackgroundProcessStatus;
    status_message?: string;
  };
};

type UseCalendarEventMeetingAgendaResult = {
  meetingAgenda: MeetingAgenda | undefined;
  isLoading: boolean;
  isError: boolean;
  error: HttpError | null;
  refetch: () => void;
};

type Props = {
  eventId: string;
  enabled?: boolean;
};

export const useCalendarEventMeetingAgenda = ({
  eventId,
  enabled = false,
}: Props): UseCalendarEventMeetingAgendaResult => {
  const { data, isFetching, isError, error, refetch } = useOne<MeetingAgenda>({
    resource: `calendar-events/${eventId}/meeting-agenda`,
    id: '',
    queryOptions: {
      enabled: enabled,
      retry: false,
      refetchInterval: data => {
        const status = data?.data?.backgroundProcess?.status;
        if (status === 'PENDING' || status === 'PROCESSING') {
          return 2000;
        }
        return false;
      },
    },
  });

  return {
    meetingAgenda: data?.data,
    isLoading: isFetching,
    isError,
    error,
    refetch,
  };
};
